import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react'
import Popup from '../../../../../components/Popup'
import { FormattedMessage, useIntl } from 'react-intl'
import { Form } from 'react-final-form'
import { Box, CircularProgress, Stack, Typography } from '@mui/material'
import TextInput from '../../../../../components/form/TextInput'
import { CREATE_CONJOINT_ACCESS } from '../../services/personalInfoConstants'
import ButtonDefault from '../../../../../components/ButtonDefault'
import { ToastType } from '../../../../../components/toast/toastConstants'
import { ToastContext } from '../../../../../components/toast/ToastContext'
import LocalStorage from '../../../../../business/storage/LocalStorage'
import UserService from '../../../../../api/gerep/UserService'
import { connect, useDispatch } from 'react-redux'
import { refreshUser } from '../../services/suggest/suggestActions'
import CheckboxInput from '../../../../../components/form/CheckboxInput'
import { cardiboxActions, cardiboxSelectors } from 'redux-cardibox'
import appConst from '../../../../../constant/appConstants'
import { userSelector } from '../../../user/userSelectors'
import { useBreakpoints } from '../../../../../components/breakpoints/BreakpointsProvider'
import { FORM_REGEX } from '../../../../../components/formConstants'
import { MODIFY_BENEFICIARY_FIELDS } from '../../../beneficiary/services/modifyBeneficiaryConstants'

type ModifyMailProps = {
	openForm: boolean
	setOpenForm: Dispatch<SetStateAction<boolean>>
	conjointEmail?: string
	articleIntro?: any
	getArticleByShortcut: any,
	setUserConjointAccess: Dispatch<SetStateAction<any>>
}

const ARTICLE_INTRO_CREATE = 'partage_acces_creation'

const CreateConjointAccessPopin: React.FC<ModifyMailProps> = ({
	setOpenForm,
	openForm,
	conjointEmail,
	articleIntro,
	getArticleByShortcut,
	setUserConjointAccess,
    // @ts-ignore
    user,
}) => {
	const intl = useIntl()
	const dispatch = useDispatch()
	const { addToast } = useContext(ToastContext)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const { isTabletPortrait } = useBreakpoints()

	useEffect(() => {
		if(!articleIntro){
			getArticleByShortcut(appConst.cardiboxApi, ARTICLE_INTRO_CREATE)
		}
	}, [])

	const handleSubmit = (values: Record<string, string>) => {
		onSubmit(values)
	}

	const onSubmit = (values: Record<string, string>) => {
		setIsLoading(true)
		return UserService.getUserConjointSendInvite({email:values[CREATE_CONJOINT_ACCESS.MAIL].trim()}, LocalStorage.getToken())
			.then((data: any) => {
				refreshUser(dispatch)
				addToast(ToastType.SUCCESS, 'personalInfo.partageConnexion.popin.sendInvite.success')
				setOpenForm(false)
				setUserConjointAccess(data)
			})
			.catch((error) => {
				if (error?.data) {
					addToast(ToastType.ERROR, error.data.newMail)
					return error.data
				} else {
					addToast(ToastType.ERROR, 'global.error.occurred')
				}
			})
			.finally(() => setIsLoading(false))
	}

	return (
		<>
			<Popup
				open={openForm}
				setOpen={setOpenForm}
				title={articleIntro && articleIntro.fields? articleIntro.fields.title : intl.formatMessage({ id: 'personalInfo.partageConnexion.popin.sendInvite.title' })}
			>
				<Form
					onSubmit={handleSubmit}
					validate={(values) => {
						const errors: Record<string, string> = {}
						if (!values[CREATE_CONJOINT_ACCESS.MAIL]) {
							errors[CREATE_CONJOINT_ACCESS.MAIL] = intl.formatMessage({ id: 'global.error.required' })
						} else if( !FORM_REGEX.EMAIL.test(values[CREATE_CONJOINT_ACCESS.MAIL])) {
							errors[CREATE_CONJOINT_ACCESS.MAIL] = intl.formatMessage({id: 'global.error.invalidEmail'})
						} else if( values[CREATE_CONJOINT_ACCESS.MAIL] === user.email) {
							errors[CREATE_CONJOINT_ACCESS.MAIL] = intl.formatMessage({ id: 'personalInfo.partageConnexion.popin.sendInvite.errorMail' })
						}

						if (!values[CREATE_CONJOINT_ACCESS.CERTIFICATION] || values[CREATE_CONJOINT_ACCESS.CERTIFICATION][0] !== "true") {
							errors[CREATE_CONJOINT_ACCESS.CERTIFICATION] = intl.formatMessage({ id: 'global.error.required' })
						}

						return errors
					}}
					render={({ handleSubmit, errors, pristine }) => (
						<form onSubmit={handleSubmit}>
							<Stack direction="column" spacing="24px">
								<Typography variant="body2">
									{(articleIntro && articleIntro.fields) && <div dangerouslySetInnerHTML={{ __html: articleIntro.fields.body }} />}
								</Typography>
								<TextInput
									type="email"
									maxWidth="unset"
									name={CREATE_CONJOINT_ACCESS.MAIL}
									label={intl.formatMessage({ id: 'personalInfo.partageConnexion.popin.sendInvite.newEmail' })}
									defaultValue={conjointEmail}
								/>
								<CheckboxInput
									name={CREATE_CONJOINT_ACCESS.CERTIFICATION}
									data={[{
										value: "true",
										label: intl.formatMessage({ id: 'personalInfo.partageConnexion.popin.sendInvite.certification' })
									}]}
									error={errors && errors[CREATE_CONJOINT_ACCESS.CERTIFICATION]}
								/>
								<Box display="flex" justifyContent="center">
									<Stack direction={isTabletPortrait ? 'column' : 'row'} spacing="12px">
										<ButtonDefault variant="outlined" onClick={() => setOpenForm(false)}>
											<FormattedMessage id="global.button.cancel" />
										</ButtonDefault>
										<ButtonDefault variant="contained" onClick={handleSubmit} disabled={pristine}>
											{isLoading ? <CircularProgress size={24} color="inherit" /> : <FormattedMessage id="personalInfo.partageConnexion.popin.sendInvite.buttonInviter" />}
										</ButtonDefault>
									</Stack>
								</Box>
							</Stack>
						</form>
					)}
				/>
			</Popup>
		</>
	)
}

const actions = {
	getArticleByShortcut: cardiboxActions.articles.getByShortcut
}

const mapStateToProps = (state: any) => ({
	articleIntro: cardiboxSelectors.articles.getByShortcut(state.cardibox).partage_acces_creation,
	user: userSelector(state)
})

export default connect(
	mapStateToProps, actions
)(CreateConjointAccessPopin)

